module.exports = __webpack_public_path__ + "img/type_photo@2x.414f72c6.png";